import { ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { BrowserModule } from '@angular/platform-browser';

// search module

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LayoutsModule } from "./layouts/layouts.module";
import { PagesModule } from "./pages/pages.module";
// progress
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
// Notifier
import { NotifierModule, NotifierOptions } from 'angular-notifier';
// Auth
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
// import { registerLicense } from '@syncfusion/ej2-base';
// import { initFirebaseBackend } from './authUtils';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';

// Language
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { provideNgxMask } from 'ngx-mask';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { FlatpickrModule } from 'angularx-flatpickr';

// Registering Syncfusion license key
// registerLicense('Mgo+DSMBaFt+QHFqVkNrWU5BaV1CX2BZellyQmlbfE4QCV5EYF5SRHJfR1xqS39Tf0VlWXo=;Mgo+DSMBPh8sVXJ1S0d+X1RPc0BHQmFJfFBmQWldeFRyd0UmHVdTRHRcQlljTH9adERjUH9ZeHE=;ORg4AjUWIQA/Gnt2VFhhQlJBfVpdWHxLflF1VWdTe1l6dlZWACFaRnZdQV1nSXtSf0diWXZeeXJQ;MTYzMzUyNUAzMjMxMmUzMTJlMzMzNVV2Q3Vzb1JUQjNLZUZ2aFpPRFVSbXR0T0J6NDBlRExJdDhvM3EyZkZvbkE9;MTYzMzUyNkAzMjMxMmUzMTJlMzMzNWd3VEY1dXlDajIyVndDSEpldFpqd3JRMlZhaUFYb29oR0hvWGcwaHhnTzg9;NRAiBiAaIQQuGjN/V0d+XU9Hc1RHQmZWfFN0RnNddVp3fldFcDwsT3RfQF5jTX5Wd0xhWH9XcXJRQw==;MTYzMzUyOEAzMjMxMmUzMTJlMzMzNUVuNUlkT2xORm51c2tSa0ZPMXRVV2dZY29zVW5WdnJuamtJcWV0R3R2ZGc9;MTYzMzUyOUAzMjMxMmUzMTJlMzMzNW4wNEtSallieEpuZUJDMlJVR2NMTmR6RGNaUnVZQlh6Vmp5ZWEwSTZKUjQ9;Mgo+DSMBMAY9C3t2VFhhQlJBfVpdWHxLflF1VWdTe1l6dlZWACFaRnZdQV1nSXtSf0diWXZccnBQ;MTYzMzUzMUAzMjMxMmUzMTJlMzMzNVE2eDByU01BNWgvb1hUY1E3alI2VmRxRDlpbFp4QmRjUEJTeGdsSzltbGs9;MTYzMzUzMkAzMjMxMmUzMTJlMzMzNWo3SnVWeG84Tnp2L1RoRTJrUmtQem95Zm1HYkY5QmpldEtDYnFLbFR6TTg9;MTYzMzUzM0AzMjMxMmUzMTJlMzMzNUVuNUlkT2xORm51c2tSa0ZPMXRVV2dZY29zVW5WdnJuamtJcWV0R3R2ZGc9');

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'bottom',
      distance: 12,
      gap: 10
    },
  },
  theme: 'material', // Better styling
  behaviour: {
    onClick: 'hide',
    showDismissButton: true,
    stacking: 4
  },
}


@NgModule({
  declarations: [
    AppComponent
  ],
  exports: [],
  bootstrap: [AppComponent], imports: [TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [HttpClient]
    }
  }),

    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    PagesModule,
    FlatpickrModule.forRoot(),
  NgProgressModule.withConfig({
    color: "#1e6ef5",
    direction: "ltr+",
    ease: "linear",
    thick: true,
    fixed: true,
    spinner: false
  }),
    NgProgressRouterModule,
    NgProgressHttpModule,
  NotifierModule.withConfig(customNotifierOptions),
    OverlayModule], providers: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      // Global Error Handler - catches chunk loading errors and auto-refreshes
      {
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
      },
      AuthService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      provideHttpClient(withInterceptorsFromDi()),
      provideNgxMask(),
      provideCharts(withDefaultRegisterables()),
      provideAnimations()
    ]
})
export class AppModule { }
